import { OnInit } from '@angular/core';
import { MatRadioChange } from '@angular/material';
import { FormGroup, Validators, NgForm, FormArray, FormBuilder } from '@angular/forms';
import { APP_DATE_FORMATS } from './date-adapter';
import { ptDateMask } from '@app/shared/utils';
var ɵ0 = APP_DATE_FORMATS;
var OccurenceDatesComponent = /** @class */ (function () {
    function OccurenceDatesComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.SINGLE_DATE = 'única data';
        this.MULTIPLE_DATES = 'múltiplas datas';
        this.SELECTED_OPTION = '';
        this.dateOptions = [this.SINGLE_DATE, this.MULTIPLE_DATES];
        this.datesMap = new Map();
        this.indexMap = new Map();
        this.datesMapFinal = new Map();
        this.indexMapFinal = new Map();
    }
    Object.defineProperty(OccurenceDatesComponent.prototype, "typesSelectedList", {
        get: function () {
            return this._typesSelectedList;
        },
        set: function (typesSelectedList) {
            this._typesSelectedList = typesSelectedList;
            this.typesSelectedListChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OccurenceDatesComponent.prototype, "occurenceTypes", {
        get: function () {
            return this._occurenceTypes;
        },
        set: function (occurenceTypes) {
            this._occurenceTypes = occurenceTypes;
        },
        enumerable: true,
        configurable: true
    });
    OccurenceDatesComponent.prototype.ngOnInit = function () {
        this.manageSelectedTypes();
    };
    Object.defineProperty(OccurenceDatesComponent.prototype, "listType", {
        get: function () {
            return this.typesSelectedList[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OccurenceDatesComponent.prototype, "dateArray", {
        get: function () {
            return this.datesForm.get('dateArray');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OccurenceDatesComponent.prototype, "dateArrayFinal", {
        get: function () {
            return this.datesForm.get('dateArrayFinal');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OccurenceDatesComponent.prototype, "dateOption", {
        get: function () {
            return this.datesForm.get('fRbDate').value;
        },
        enumerable: true,
        configurable: true
    });
    OccurenceDatesComponent.prototype.getDatePickerLabel = function (index) {
        if (this.isVisualization) {
            return this.typesSelectedList[0].length > 1 ? this.typesSelectedList[0][index].name : '';
        }
        else if (!this.isVisualization && this.dateOption === this.SINGLE_DATE) {
            return '';
        }
        else {
            return this.typesSelectedList[0][index].name;
        }
    };
    OccurenceDatesComponent.prototype.typesSelectedListChange = function () {
        if (this.datesForm) {
            this.refreshDateArray(this.dateOption);
            this.refreshDateArrayFinal(this.dateOption);
        }
    };
    OccurenceDatesComponent.prototype.dateOptionsChange = function (mrChange) {
        this.refreshDateArray(mrChange.value);
        this.refreshDateArrayFinal(mrChange.value);
    };
    OccurenceDatesComponent.prototype.addDate = function (typeId, index) {
        if (this.datesMap.has(typeId)) {
            this.dateArray.push(this.formBuilder.control({ value: this.datesMap.get(typeId), disabled: this.isVisualization }, [Validators.required, ptDateMask]));
            this.indexMap.set(index.toString(), typeId);
        }
        else {
            this.dateArray.push(this.formBuilder.control({ value: '', disabled: this.isVisualization }, [Validators.required, ptDateMask]));
            this.indexMap.set(index.toString(), typeId);
        }
    };
    OccurenceDatesComponent.prototype.addDateFinal = function (typeId, index) {
        var required = [];
        if (Array.isArray(this.selectedDates) && this.selectedDates.length > 0) {
            required = [Validators.required, ptDateMask];
        }
        if (this.datesMapFinal.has(typeId)) {
            this.dateArrayFinal.push(this.formBuilder.control({ value: this.datesMapFinal.get(typeId), disabled: this.isVisualization }, required));
            this.indexMapFinal.set(index.toString(), typeId);
        }
        else {
            this.dateArrayFinal.push(this.formBuilder.control({ value: '', disabled: this.isVisualization }, required));
            this.indexMapFinal.set(index.toString(), typeId);
        }
    };
    OccurenceDatesComponent.prototype.saveDateValues = function () {
        if (this.datesForm.get('dateArray')) {
            if (this.typesSelectedList.length > 0 && this.typesSelectedList[0].length > 0) {
                for (var _i = 0, _a = this.dateArray.controls.map(function (item, index) { return ({ item: item, index: index }); }); _i < _a.length; _i++) {
                    var _b = _a[_i], item = _b.item, index = _b.index;
                    var typeId = this.indexMap.get(index.toString());
                    this.datesMap.set(typeId, item.value);
                }
            }
        }
        if (this.datesForm.get('dateArrayFinal')) {
            if (this.typesSelectedList.length > 0 && this.typesSelectedList[0].length > 0) {
                for (var _c = 0, _d = this.dateArrayFinal.controls.map(function (item, index) { return ({ item: item, index: index }); }); _c < _d.length; _c++) {
                    var _e = _d[_c], item = _e.item, index = _e.index;
                    var typeId = this.indexMapFinal.get(index.toString());
                    this.datesMapFinal.set(typeId, item.value);
                }
                this.indexMapFinal.clear();
            }
        }
    };
    OccurenceDatesComponent.prototype.refreshDateArray = function (dateOption) {
        var indexMapBackup = this.indexMap;
        this.saveDateValues();
        this.datesForm.removeControl('dateArray');
        this.datesForm.addControl('dateArray', this.formBuilder.array([]));
        if (this.typesSelectedList.length > 0) {
            if (dateOption === this.SINGLE_DATE && !this.isVisualization) {
                if (this.typesSelectedList[0].length > 0) {
                    this.addDate('-1', 0);
                }
            }
            else {
                for (var _i = 0, _a = this.typesSelectedList[0].map(function (item, index) { return ({ item: item, index: index }); }); _i < _a.length; _i++) {
                    var _b = _a[_i], item = _b.item, index = _b.index;
                    this.addDate(item.id.toString(), index);
                }
            }
        }
    };
    OccurenceDatesComponent.prototype.refreshDateArrayFinal = function (dateOption) {
        this.saveDateValues();
        this.datesForm.removeControl('dateArrayFinal');
        this.datesForm.addControl('dateArrayFinal', this.formBuilder.array([]));
        if (this.typesSelectedList.length > 0) {
            if (dateOption === this.SINGLE_DATE && !this.isVisualization) {
                if (this.typesSelectedList[0].length > 0) {
                    this.addDateFinal('-1', 0);
                }
            }
            else {
                for (var _i = 0, _a = this.typesSelectedList[0].map(function (item, index) { return ({ item: item, index: index }); }); _i < _a.length; _i++) {
                    var _b = _a[_i], item = _b.item, index = _b.index;
                    this.addDateFinal(item.id.toString(), index);
                }
            }
        }
    };
    OccurenceDatesComponent.prototype.manageSelectedTypes = function () {
        var _this = this;
        if (Array.isArray(this.selectedDates) && this.selectedDates.length > 0) {
            // if (this.dateOption === this.SINGLE_DATE) {
            //   this.selectedDates.forEach((item, i) => {
            //     this.datesMap.set(i.toString(), new Date(item.suggestedDate.toString().split('-').join('/')));
            //     this.datesMapFinal.set(i.toString(), item.approvedDate ? new Date(item.approvedDate.toString().split('-').join('/')) : '');
            //   });
            // } else {
            this.selectedDates.forEach(function (item) {
                if (item.suggestedDate) {
                    _this.datesMap.set(item.occurrenceType.id.toString(), new Date(item.suggestedDate.toString().split('-').join('/')));
                }
                if (item.approvedDate) {
                    _this.datesMapFinal.set(item.occurrenceType.id.toString(), item.approvedDate ? new Date(item.approvedDate.toString().split('-').join('/')) : '');
                }
            });
            // }
        }
    };
    return OccurenceDatesComponent;
}());
export { OccurenceDatesComponent };
export { ɵ0 };
